import type { ILegalText } from "~/models/ILegalText";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import type { IDetailParagraphEntry } from "~/models/IUserEntry";

export default function useParagraphMeta(
  legalText: MaybeRefOrGetter<ILegalText | undefined>,
  paragraph: MaybeRefOrGetter<ILegalTextParagraph | undefined>,
  entry: MaybeRefOrGetter<IDetailParagraphEntry | undefined>
) {
  const maxLength = 200;
  const { t } = useI18n();
  const baseTitle = computed(() => {
    const legalTextVal = toValue(legalText);
    const paragraphVal = toValue(paragraph);
    const entryVal = toValue(entry);

    if (entryVal?.type === "schema" && entryVal.curated) {
      return entryVal.title;
    }

    if (paragraphVal) {
      const { paragraph, title, legal_text } = paragraphVal;
      let res = [paragraph, legal_text?.name].join(" ");
      if (title) {
        res = [res, title].join(" - ");
      }
      return res;
    }

    return legalTextVal?.name;
  });

  const title = computed(() => `${baseTitle.value} | LexMea`);

  const description = computed(() => {
    const paragraphVal = toValue(paragraph);
    const entryVal = toValue(entry);

    if (entryVal?.type === "schema" && entryVal.curated) {
      const summary = useSchemaSummary(entryVal);
      if (summary) {
        return useTruncateText(summary, maxLength);
      }
    }

    if (paragraphVal) {
      return useParagraphDescription(paragraphVal.nodes, maxLength);
    }

    return `${title.value} - ${t("legal_text.toc")}`;
  });

  const config = useConfig();

  return () => config({ title: title.value, description: description.value });
}
